import { ROOM_CODE_LENGTH, roomCodeSchema } from '@xox/shared'
import { type FormEvent, useState } from 'react'
import { Button, Input } from './ui'

interface Props {
  id: string
  label: string
  onJoin: (code: string) => void
}

/** "Have a code?" input shared by every game's home page. */
export function JoinCodeForm({ id, label, onJoin }: Props) {
  const [code, setCode] = useState('')
  const [error, setError] = useState<string | null>(null)

  const submit = (e: FormEvent) => {
    e.preventDefault()
    const parsed = roomCodeSchema.safeParse(code)
    if (!parsed.success) {
      setError(`Codes are ${ROOM_CODE_LENGTH} letters and numbers`)
      return
    }
    onJoin(parsed.data)
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-2">
      <label htmlFor={id} className="text-sm font-medium">
        {label}
      </label>
      <div className="flex gap-2">
        <Input
          id={id}
          value={code}
          onChange={(e) => {
            setCode(e.target.value.toUpperCase())
            setError(null)
          }}
          placeholder="ABCD2345"
          maxLength={ROOM_CODE_LENGTH}
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          className="font-mono tracking-widest uppercase"
        />
        <Button type="submit" variant="secondary">
          Join
        </Button>
      </div>
      {error && <p className="text-sm text-rose-600">{error}</p>}
    </form>
  )
}
